import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Carrusel from "@/components/Carrusel";
import Buscador from "@/components/Buscador";
import ComoFunciona from "@/components/ComoFunciona";
import PorQueElegir from "@/components/PorQueElegir";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Landing() {
  React.useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div style={{ background: "var(--af-black)" }}>
      <Navbar />
      <Hero />
      <Carrusel />
      <Buscador />
      <ComoFunciona />
      <PorQueElegir />
      <FAQ />
      <Footer />
    </div>
  );
}
